import React from 'react'

export default function EmptyCart() {
    return (
        <div className="container mt-5">
            <div className="row"></div>
                <div className="col-10 mx-auto text-center text-title"></div>
                <h1 className="text-capitalize text-center ">your cart is empty</h1>
        </div>
    )
}
